// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"233":"072c3f79","313":"a512cf58","425":"d86d5ac3","728":"4db86cee","878":"afe1a87e","980":"49496441"}[chunkId] + ".chunk.js";
};